var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtrUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 64,
    viewBox: "0 0 96 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.4 24.16C76.0564 17.3509 72.3904 11.2194 67.0283 6.81298C61.6661 2.40653 54.9404 -0.00156897 48 7.66947e-07C36.44 7.66947e-07 26.4 6.56 21.4 16.16C15.5209 16.7953 10.084 19.5808 6.13396 23.9813C2.18388 28.3817 -0.000686807 34.0867 1.61971e-07 40C1.61971e-07 53.24 10.76 64 24 64H76C87.04 64 96 55.04 96 44C96 33.44 87.8 24.88 77.4 24.16ZM53.1948 36V52H43.3247V36H34.9923C34.1679 36 33.6977 35.0586 34.1927 34.3994L46.961 17.4C47.761 16.6 48.239 16.6 49.039 17.4L61.9496 34.3951C62.4498 35.0535 61.9802 36 61.1533 36H53.1948Z",
    fill: "#154063"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtrUpload);
export default __webpack_public_path__ + "static/media/CtrUpload.ab8d5bd0858e904e8cefa5b96c2730aa.svg";
export { ForwardRef as ReactComponent };